import React from 'react';
import { badge as badgeStyles } from '../../utils/designTokens';

/**
 * Badge - Consistent badge/pill component
 * Variants: default, primary, success, warning, danger, info
 */
const Badge = ({
  children,
  variant = 'default',
  className = '',
}) => {
  const variantClass = badgeStyles[variant] || badgeStyles.default;

  return (
    <span className={`${variantClass} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
